export default {"src":"/_next/static/media/dtr.b866bd3c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};